var map = {
	"./bs_banner.jpg": "72938",
	"./bs_banner_en.jpg": "edba",
	"./bs_banner_es.jpg": "a8c6f",
	"./bs_banner_hk.jpg": "96fd",
	"./bs_banner_pt.jpg": "1cde",
	"./bs_banner_tr.jpg": "4fb7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1226";